/* istanbul ignore file */
import { FC, ComponentType, useEffect } from 'react';
import { notification } from '@duxton-web/ui';
import { t } from 'i18next';
import worker from './worker';

const onServiceWorkerUpdate = (eventName: string) => {
  switch (eventName) {
    case 'update-installed':
      notification.info({
        duration: 0,
        message: t('dna_smartLink_heading_newVersionUpdate', 'New Version Update'),
        description: t(
          'dna_smartLink_snackbar_newVersionDownloaded',
          'A new version has been downloaded, please refresh the page to update to latest version.',
        ),
        placement: 'bottomLeft',
      });
      break;
    default:
  }
};

const WithUpdateWorker = (WrappedComponent: ComponentType): ComponentType => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithWorker: FC = (props) => {
    useEffect(() => {
      worker.register(onServiceWorkerUpdate);
    }, []);

    return <WrappedComponent {...props} />;
  };

  ComponentWithWorker.displayName = `WithUpdateWorker(${displayName})`;

  return ComponentWithWorker;
};

export default WithUpdateWorker;
